import { render } from "./private.vue?vue&type=template&id=587a373a&scoped=true"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"

import "./private.vue?vue&type=style&index=0&id=587a373a&lang=css"
import "./private.vue?vue&type=style&index=1&id=587a373a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587a373a"]])

export default __exports__